import Vue from 'vue'
import Router from 'vue-router'

import dft from './layout/default.vue'
import empty from './layout/empty.vue'

import index from './views/index.vue'

import order from './views/order.vue'
import market from './views/market.vue'
import orderDetails from './views/orderDetails.vue'
import voucher from './views/voucher.vue'
import wallet from './views/wallet.vue'
import records from './views/records.vue'
import recordDetails from './views/recordDetails.vue'
import qrcode from './views/qrcode.vue'
import mine from './views/mine.vue'
import accounts from './views/accounts.vue'
import addAccount from './views/addAccount.vue'
import editAccount from './views/editAccount.vue'
import auth from './views/auth.vue'
import reset from './views/reset.vue'
import setting from './views/setting.vue'
import editIpt from './views/editIpt.vue'
import addFixedLimitQrcode from './views/addFixedLimitQrcode.vue'
import editFixedLimitQrcode from './views/editFixedLimitQrcode.vue'
import orderQrCodeDetail from './views/orderQrCodeDetail.vue'

import login from './views/login.vue'
import register from './views/register.vue'
import forgot from './views/forgot.vue'
import errPage from './views/errPage.vue'
import wifi from './views/wifi.vue'

// banner页面
import banner from './views/banner.vue'

import orderTab from './views/orderTab.vue'
import orderbuyDetail from './views/orderbuyDetail.vue'
//聊天界面
import chat from './views/chat.vue'

import addAlipay from './views/addAlipay.vue'
import editAlipay from './views/editAlipay.vue'
//收款方式分组管理
import bankGroupManage from './views/bankGroupManage.vue'
import addBankGroup from './views/addBankGroup.vue'
import editBankGroup from './views/editBankGroup.vue'
// import download from './views/download.vue'
Vue.use(Router)

export default new Router({
	//mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'empty',
			component: empty,
			children: [
				{
					path: '/',
					name: 'login',
					component: login
				},
				{
					path: '/orderDetails',
					name: 'orderDetails',
					component: orderDetails
				},
				{
					path: '/orderbuyDetail',
					name: 'orderbuyDetail',
					component: orderbuyDetail
				},
				{
					path: '/records',
					name: 'records',
					component: records
				},
				{
					path: '/recordDetails',
					name: 'recordDetails',
					component: recordDetails
				},
				{
					path: '/qrcode',
					name: 'qrcode',
					component: qrcode
				},
				{
					path: '/accounts',
					name: 'accounts',
					component: accounts
				},
				{
					path: '/addAccount',
					name: 'addAccount',
					component: addAccount
				},
				{
					path: '/addFixedLimitQrcode',
					name: 'addFixedLimitQrcode',
					component: addFixedLimitQrcode
				},
				{
					path: '/editFixedLimitQrcode',
					name: 'editFixedLimitQrcode',
					component: editFixedLimitQrcode
				},
				{
					path: '/editAccount',
					name: 'editAccount',
					component: editAccount
				},
				{
					path: '/auth',
					name: 'auth',
					component: auth
				},
				{
					path: '/chat',
					name: 'chat',
					component: chat
				},
				{
					path: '/reset',
					name: 'reset',
					component: reset
				},
				{
					path: '/setting',
					name: 'setting',
					component: setting
				},
				{
					path: '/editIpt',
					name: 'editIpt',
					component: editIpt
				},

				{
					path: '/register',
					name: 'register',
					component: register
				},
				{
					path: '/forgot',
					name: 'forgot',
					component: forgot
				},
				{
					path: '/wifi',
					name: 'wifi',
					component: wifi
				},

				{
					path: '/orderTab',
					name: 'orderTab',
					component: orderTab
				},

				{
					path: '/banner',
					name: 'banner',
					component: banner
				},
				//   {
				// 	  path: '/download',
				// 	  name: 'download',
				// 	  component: download
				//   },
				{
					path: '/errPage',
					name: 'errPage',
					component: errPage
				},
				//   { 
				// 	path: '*', 
				// 	redirect: '/errPage'
				//   }
				{
					path: '/addAlipay',
					name: 'addAlipay',
					component: addAlipay
				},
				{
					path: '/editAlipay',
					name: 'editAlipay',
					component: editAlipay
				},
				{
					path: '/bankGroupManage',
					name: 'bankGroupManage',
					component: bankGroupManage
				},
				{
					path: '/addBankGroup',
					name: 'addBankGroup',
					component: addBankGroup
				},
				{
					path: '/editBankGroup',
					name: 'editBankGroup',
					component: editBankGroup
				},
				{
					path: '/voucher',
					name: 'voucher',
					component: voucher
				}
				,
				{
					path: '/orderQrCodeDetail',
					name: 'orderQrCodeDetail',
					component: orderQrCodeDetail
				}
			]
		},
		{
			path: '/dft',
			name: 'dft',
			component: dft,
			children: [
				{
					path: '/index',
					name: 'index',
					component: index
				},
				{
					path: '/market',
					name: 'market',
					component: market
				},
				{
					path: '/order',
					name: 'order',
					component: orderTab
				},
				{
					path: '/wallet',
					name: 'wallet',
					component: wallet
				},
				{
					path: '/mine',
					name: 'mine',
					component: mine
				}
			]
		}
	]
})
